// @flow
import { useMemo } from 'react'

/**
 * Preload image to cache on the client
 * @param {string} url - URL of image to preload
 */
export function preloadImage(url: string) {
  if (url && typeof url === 'string') {
    const image = new Image()
    image.src = url
  }
}

/**
 * Preload image hook to cache on the client (for functional components)
 * @param {string} url - URL of image to preload
 */
export function usePreloadImage(url: string) {
  useMemo(() => preloadImage(url), [url])
}
